<mat-sidenav-container class="sidenav-container">
  <mat-sidenav
    #drawer
    class="sidenav"
    [fixedInViewport]="isMobileLayout"
    [attr.role]="'navigation'"
    [mode]="sidenavMode"
    [opened]="sidenavOpened"
    [disableClose]="false"
    (openedChange)="onSidenavOpenedChange($event)">
    <div class="sidenav-header">
      <img [src]="logoSrc" [attr.alt]="logoAlt" class="app-logo" />

      <h2 class="app-title">{{ branding.sidebarTitle }}</h2>
      <p class="app-subtitle">{{ branding.sidebarSubtitle }}</p>
      <div class="app-tagline">{{ branding.sidebarTagline }}</div>
    </div>

    @if (currentUser) {
      <div class="sidenav-body">
        <mat-nav-list class="navigation-list">
          @for (item of navigationItems; track item) {
            <a
              mat-list-item
              class="nav-item"
              [class.active-link]="isNavItemActive(item)"
              [attr.href]="item.path"
              [attr.aria-current]="isNavItemActive(item) ? 'page' : null"
              (click)="onNavItemClick($event, item)"
              >
              <mat-icon matListItemIcon>{{ item.icon }}</mat-icon>
              <span matListItemTitle>{{ item.label }}</span>
            </a>
          }
        </mat-nav-list>
        <div class="sidenav-footer">
          <mat-nav-list>
            @if (canAccessSettings()) {
              <a
                mat-list-item
                class="nav-item settings-nav-item"
                [class.active-link]="isSettingsActive()"
                (click)="openSettings()"
                >
                <mat-icon matListItemIcon>settings</mat-icon>
                <span matListItemTitle>Settings</span>
              </a>
            }
          </mat-nav-list>
        </div>
      </div>
    }

  </mat-sidenav>

  <mat-sidenav-content class="sidenav-content" [class.sidenav-expanded]="!sidenavOpened">
    <mat-toolbar color="primary">
      <button mat-icon-button class="sidenav-toggle-button" (click)="toggleSidenav()">
        <mat-icon>menu</mat-icon>
      </button>

      <span class="toolbar-title-wrap">
        <span class="toolbar-title">{{ branding.toolbarTitle }}</span>
    </span>

    <span class="toolbar-spacer"></span>

    @if (currentUser) {
      <button mat-icon-button (click)="downloadUserGuide()" matTooltip="User Guide" matTooltipPosition="left">
        <mat-icon>help_outline</mat-icon>
      </button>
      <button
        #userMenuTrigger="matMenuTrigger"
        mat-icon-button
        [matMenuTriggerFor]="userMenu"
        (menuOpened)="onUserMenuOpened()">
        <mat-icon>account_circle</mat-icon>
      </button>
      <mat-menu #userMenu="matMenu" panelClass="saferoads-user-menu-panel" xPosition="before" yPosition="below">
        <div class="user-menu">
          <div class="user-menu__header">
            <div class="user-menu__avatar" aria-hidden="true">{{ getUserInitials() }}</div>
            <div class="user-menu__meta">
              <div class="user-menu__name">{{ getUserDisplayName() }}</div>
              @if (getRoleLabel() && getRoleLabel() !== getUserDisplayName()) {
                <div class="user-menu__role">{{ getRoleLabel() }}</div>
              }
              <div class="user-menu__email">{{ currentUser.email }}</div>
            </div>
          </div>
          <mat-divider></mat-divider>
          <button mat-menu-item class="user-menu__logout" (click)="logout()">
            <mat-icon>logout</mat-icon>
            <span>Logout</span>
          </button>
        </div>
      </mat-menu>
    }
  </mat-toolbar>

  <div class="page-shell">
    <div class="content">
      <ng-content></ng-content>
    </div>
  </div>
</mat-sidenav-content>
</mat-sidenav-container>
